import React from 'react';
import { useSettings } from '../context/SettingsContext';
import api from '../api';

const SocialFloat = () => {
  const { settings } = useSettings();

  const hasAnySocial = settings.zalo_url || settings.facebook_url || settings.phone;

  const handleTrack = (eventType) => {
    if (window.currentTrackTarget && window.currentTrackTarget.type && window.currentTrackTarget.id) {
      api.trackEvent(window.currentTrackTarget.type, window.currentTrackTarget.id, eventType);
    }
  };

  if (!hasAnySocial) return null;

  return (
    <div className="social-float">
      {settings.zalo_url && (
        <a 
          href={settings.zalo_url} 
          className="social-float-link zalo" 
          target="_blank" 
          rel="noopener noreferrer" 
          aria-label="Zalo"
          onClick={() => {
            handleTrack('zalo');
            if (window.gtag_report_conversion) window.gtag_report_conversion(settings.zalo_url);
          }}
        >
          <img src="/images/zalo.svg" alt="Zalo" style={{ width: '28px', height: '28px', verticalAlign: 'middle' }} />
        </a>
      )}
      {settings.facebook_url && (
        <a 
          href={settings.facebook_url} 
          className="social-float-link facebook" 
          target="_blank" 
          rel="noopener noreferrer" 
          aria-label="Facebook"
          onClick={() => handleTrack('facebook')}
        >
          <i className="fab fa-facebook-f"></i>
        </a>
      )}
      {settings.phone && (
        <a 
          href={`tel:${settings.phone}`} 
          className="social-float-link phone" 
          aria-label="Gọi điện"
          onClick={() => {
            handleTrack('phone');
            if (window.gtag_report_conversion) window.gtag_report_conversion(`tel:${settings.phone}`);
          }}
        >
          <i className="fas fa-phone-alt"></i>
        </a>
      )}
    </div>
  );
};

export default SocialFloat;
